/* eslint-disable react/jsx-props-no-spreading */
import { GridCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import MobileSummaryCellItem from './MobileSummaryCellItem';

const FullNameCell = (cellProps: GridCellProps) => (
	<td>
		<FullNameCellContent {...cellProps} />
	</td>
);

export default FullNameCell;

export const FullNameCellContent = (props: Props) => (
	<MobileSummaryCellItem
		title={props.title ? `${props.title}` : ''}
		value={`${props.dataItem.firstName} ${props.dataItem.lastName}`}
	/>
);

interface Props extends GridCellProps {
	title?: string; // desktop view doesn't have title
}
